import React from "react";
import { Paper } from "@mui/material";
import { addCommas } from "src/storage/helpers";
import styled from "styled-components";

const Card = styled(Paper)`
  padding: 14px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 12px;
  width: 100%;
  flex-grow: 1;
  transition: border 300ms ease-in;

  @media (max-width: 600px) {
    padding: 8px;
  }
`;

const CardItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-left: 1px solid lightgray;
  padding-right: 12px;
  padding-left: 6px;
`;

const TextOne = styled.span`
  font-size: 15px;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, sans-serif;
`;

const TextThree = styled.span`
  color: slategrey;
  font-weight: 400;
  font-size: 12px;
  text-transform: capitalize;
  white-space: nowrap;
`;

const ItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 22px;
  flex: 1 1 100%;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  padding-bottom: 10px;

  &::-webkit-scrollbar {
    height: 8px;
  }

  scrollbar-width: auto;
  scrollbar-color: #ccc transparent;
`;

const CompanyName = styled.p`
  font-size: 16px;
  font-weight: 600;
  margin-top: 6px;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;

const CompanyCard = ({ company }) => (
  <Card key={company?.company_id}>
    <img
      style={{
        height: 100,
        width: 100,
        minWidth: 100,
        marginRight: 12,
        borderRadius: 12,
        background: "white",
        border: "1px solid lightgray",
        objectFit: "contain",
      }}
      src={company?.image}
      alt="company-logo"
    />
    <div
      style={{
        overflow: "hidden",
        flex: 1,
        minHeight: 100,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
      }}
    >
      <CompanyName>{company.company_name}</CompanyName>
      <div style={{ minHeight: 10 }} />
      <ItemContainer>
        <CardItem>
          <TextOne>
            <b>{addCommas(company?.data?.submissions?.submissions)}</b>
          </TextOne>
          <TextThree>submissions</TextThree>
        </CardItem>
        <CardItem>
          <TextOne>
            <b>{addCommas(company?.data?.submissions?.completions)}</b>{" "}
          </TextOne>
          <TextThree>completions</TextThree>
        </CardItem>
        <CardItem>
          <TextOne>
            <b>{addCommas(company?.data?.team_members?.overall)}</b>
          </TextOne>
          <TextThree>team members</TextThree>
        </CardItem>
        <CardItem>
          <TextOne>
            <b>{addCommas(company?.data?.live_modules)}</b>
          </TextOne>
          <TextThree>live modules</TextThree>
        </CardItem>
        <CardItem>
          <TextOne>
            <b>{addCommas(company?.data?.team_members?.recently_active)}</b>
          </TextOne>
          <TextThree>active team members</TextThree>
        </CardItem>
        <CardItem>
          <TextOne>
            <b>{addCommas(company?.data?.submissions?.recent_submissions)}</b>
          </TextOne>
          <TextThree>Recent Submissions</TextThree>
        </CardItem>
        <CardItem>
          <TextOne>
            <b>{addCommas(company?.data?.submissions?.recent_completions)}</b>
          </TextOne>
          <TextThree>Recent Completions</TextThree>
        </CardItem>
      </ItemContainer>
    </div>
  </Card>
);

export default CompanyCard;
